/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createQuickBooksTokenResponseFromDiscriminatorValue, serializeQuickBooksTokenRequest, serializeQuickBooksTokenResponse, type ErrorResponse, type InternalErrorResponse, type QuickBooksTokenRequest, type QuickBooksTokenResponse } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/quickbooks/callback
 */
export interface CallbackRequestBuilder extends BaseRequestBuilder<CallbackRequestBuilder> {
    /**
     * Finishes the connection started by the authorization endpoint: exchanges the authorization code QuickBooks handed back for the tokens that let this API read the company's accounting data, and stores them against the organization. Send the code and the realmId exactly as QuickBooks returned them — a code is single-use and expires within minutes, so a code that has already been redeemed or has aged out cannot be retried and the administrator has to start again from the authorization endpoint. Calling this again for the same organization replaces the stored connection. The tokens come back for confirmation only; they are kept here and refreshed as needed, so a caller does not have to store them.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<QuickBooksTokenResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: QuickBooksTokenRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<QuickBooksTokenResponse | undefined>;
    /**
     * Finishes the connection started by the authorization endpoint: exchanges the authorization code QuickBooks handed back for the tokens that let this API read the company's accounting data, and stores them against the organization. Send the code and the realmId exactly as QuickBooks returned them — a code is single-use and expires within minutes, so a code that has already been redeemed or has aged out cannot be retried and the administrator has to start again from the authorization endpoint. Calling this again for the same organization replaces the stored connection. The tokens come back for confirmation only; they are kept here and refreshed as needed, so a caller does not have to store them.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: QuickBooksTokenRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const CallbackRequestBuilderUriTemplate = "{+baseurl}/api/quickbooks/callback";
/**
 * Metadata for all the requests in the request builder.
 */
export const CallbackRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: CallbackRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createQuickBooksTokenResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeQuickBooksTokenRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
